import { Injectable } from '@angular/core';
import {ApiService, EnvironmentModel, GenericMessage} from '@cas-hub/acabim-common-client';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TasksService extends ApiService {
  protected controller = 'super/run';

  constructor(
      protected client: HttpClient,
      protected environment: EnvironmentModel
  ) {
    super(client, environment);
  }

  public runTasks() {
    return this.client.post(this.url('actions'), {}, {
      headers: this.defaultHeaders,
      responseType: 'json'
    }).pipe(map(item => item as GenericMessage));
  }

} //EOC
